import owlCarousel from "owl.carousel";
import lightcase from "lightcase";
import Main from "./_main.es6";
import ProtectImg from "./_protectimg.es6";
import ScrollAnime from './_scroll.es6';
import Modal from './modal/_modal.es6';
import Movie from './modal/_movie.es6';

const main = new Main();
const modal = new Modal();
const movie = new Movie();
const protectImg = new ProtectImg(); //画像保護＋右クリック阻止
const scrollAnime = new ScrollAnime();
